// import { CurrencyPipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ReporteriaService } from 'src/app/services/convenio/reporteria.service';
import { AppState } from 'src/app/state/app.state';
import { selectUser } from 'src/app/state/selectors/user.selectors';

@Component({
  selector: 'app-acta-gxe',
  templateUrl: './acta-gxe.component.html',
  styleUrls: ['./acta-gxe.component.scss']
})
export class ActaGxeComponent implements OnInit {
  @Input() turnosActivos: any;
  @Input() jefesTurno:any;
  @Input() cobradores:any;
  formBusqueda:FormGroup;
  caseta:number;
  turnosNames = {
    1: 'PRIMERO',
    2: 'SEGUNDO',
    3: 'TERCERO'
  }
  carriles:any[] = [];
  previewActaBase64:any = null;
  constructor(
    private formBuilder: FormBuilder,
    private store: Store<AppState>,
    private reporteService:ReporteriaService,
    private ngxUiLoaderService:NgxUiLoaderService,
    private toastr:ToastrService,
    // private currencyPipe: CurrencyPipe
  ) { }

  ngOnInit(): void {
    this.createForm();
    this.getData();
  }

  createForm() {
    this.formBusqueda = this.formBuilder.group({
      fecha: ['', Validators.required], //fecha obligatoria
      jefeTurno: ['', Validators.required],
      turno: ['', Validators.required],
      carril : ['', Validators.required],
      cobrador : ['', Validators.required],
      pagoCorrecto: ['',Validators.required],
      pagoIncorrecto: ['',Validators.required],
      folio: ['',Validators.required],
      importe: ['',Validators.required],
      dateTermino: ['',Validators.required]
    });
  }

  async  getData() {
    this.ngxUiLoaderService.start('1');
    this.caseta = this.getCasetaUser().id;
    this.carriles = await this.getCarrilesByCaseta(this.caseta);
    this.ngxUiLoaderService.stop('1');
  }

  getCasetaUser() {
    let casetaTroncal;
    this.store.select(selectUser).subscribe( usuario => { // Obtener info del usuario
      casetaTroncal = usuario.caseta_usuario.find(caseta => caseta.tipo === 1);// Obtener caseta troncal
    });
    return casetaTroncal;
  }

  getCarrilesByCaseta(id_caseta:number) {
    return this.reporteService.getCarriles(id_caseta);
  }

  getTurnos(){
    return this.reporteService.getTurnos();
  }

  getJefesTurno(tipoUser:number) {
    return this.reporteService.getUsersTipo(tipoUser);
  }

  getCobradores(tipoUser:number) {
    return this.reporteService.getUsersTipo(tipoUser);
  }

  previewPDF() {
    this.ngxUiLoaderService.start('preview');
    let form = {...this.formBusqueda.value, caseta: this.caseta, download: false};
    this.reporteService.getPreviewActa(2, form)//numero pagina , formData
    .then(data => {
         console.log(data);
         this.ngxUiLoaderService.stop('preview');
         this.previewActaBase64 = data+"#toolbar=1";
    })
    .catch(error => {
      this.ngxUiLoaderService.stop('preview');
      this.toastr.error('Algo salio mál, favor de volver a intenter la descarga del PDF', `${error}`, { positionClass: 'toast-bottom-right' } )
    });
  }

  downloadPDF() {

  }

  transformTextUpper(event) {
    console.log(event);
    this.formBusqueda.get(`${event.target.name}`).setValue(event.target.value.toUpperCase());
  }
  transformMoney(event) {
    //PENDIENTE
    // const value = parseFloat(event.target.value);
    // let money = parseFloat(this.currencyPipe.transform(value, 'MXN', 'symbol', '1.2-2'));
    // console.log(money);
    // if (!isNaN(value)) {
    //    this.formBusqueda.get('importe').setValue(this.decimalPipe.transform(value, 'MXN', 'symbol'));//fecha actual
    // } else {
    //   return value; // Devuelve el valor original si no es un número válido
    // }
  }

}
